import React, { createContext } from 'react';
import { KlaviyoClient } from '@jbhi-fi/apis/src/klaviyo/KlaviyoClient';
import { KlaviyoOnSiteClient } from '@jbhi-fi/apis/src/klaviyo/KlaviyoOnSiteClient';
import { KlaviyoBackInStoreClient } from '@jbhi-fi/apis/src/klaviyo/KlaviyoBackInStoreClient';
import { ContentfulThemeApiClient } from '@jbhi-fi/apis/src/contentfulThemeApi';
import { OrderTrackingThemeApiClient } from '@jbhi-fi/apis/src/orderTrackingThemeApi/OrderTrackingThemeApiClient';
import { ServicesApiClient } from '@jbhi-fi/apis/src/services/ServicesApiClient';
import { StoreClient } from '@jbhi-fi/apis/src/algolia/StoreClient';
import { FulfilmentClient } from '@jbhi-fi/apis/src/fulfilment';
import { TaxInvoicesClient } from '@jbhi-fi/apis/src/taxInvoices/TaxInvoicesClient';
import { OnlineMarketingApiClient } from '@jbhi-fi/apis/src/onlineMarketingApi/OnlineMarketingApiClient';

export type PublicApiClientContextProps = {
  klaviyoClient?: KlaviyoClient;
  klaviyoOnSiteClient?: KlaviyoOnSiteClient;
  klaviyoBackInStoreClient?: KlaviyoBackInStoreClient;
  contentfulThemeApiClient?: ContentfulThemeApiClient;
  orderTrackingThemeApiClient?: OrderTrackingThemeApiClient;
  servicesApiClient?: ServicesApiClient;
  algoliaStoreApiClient?: StoreClient;
  fulfilmentClient?: FulfilmentClient;
  taxInvoicesClient?: TaxInvoicesClient;
  onlineMarketingApiClient?: OnlineMarketingApiClient;
};

export const PublicApiClientContext = createContext<PublicApiClientContextProps | Record<any, any>>({});

type ApiClientProviderProps = PublicApiClientContextProps & {
  children: React.ReactNode;
};

/**
 * The PublicApiClientProvider exposes api clients are safe to expose to client side code. Only used for API clients
 * that do not contain sensitive data such as private API keys
 */
export const PublicApiClientProvider = ({
  klaviyoClient,
  klaviyoOnSiteClient,
  klaviyoBackInStoreClient,
  contentfulThemeApiClient,
  orderTrackingThemeApiClient,
  servicesApiClient,
  algoliaStoreApiClient,
  fulfilmentClient,
  taxInvoicesClient,
  onlineMarketingApiClient,
  children,
}: ApiClientProviderProps) => (
  <PublicApiClientContext.Provider
    value={{
      klaviyoClient,
      klaviyoOnSiteClient,
      klaviyoBackInStoreClient,
      contentfulThemeApiClient: contentfulThemeApiClient,
      orderTrackingThemeApiClient,
      servicesApiClient,
      algoliaStoreApiClient,
      fulfilmentClient,
      taxInvoicesClient,
      onlineMarketingApiClient,
    }}
  >
    {children}
  </PublicApiClientContext.Provider>
);
